import { createContext } from "react";
import { RoutineEventModel } from "services/routine/routine.model";

export interface editRoutineContextData {
	showModal: boolean;
	slot: RoutineEventModel | null;
}

export const editRoutineContext = createContext<editRoutineContextData>({
	slot: null,
	showModal: false,
});
